import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
export default class SharingPageVisitTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'Sharing';
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.ACCOUNT_SETTINGS.SHARING_PAGE_VISIT, ($e, data) => this.trackButtonEventSegment(data));
    }
}
